import HealthInsuranceList from './HealthInsuranceList'

const index = () => {
  return <HealthInsuranceList />
}

export default index